/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useState, useEffect } from 'react';

import { useForm } from 'react-hook-form';

import { format, parseISO } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

import { ClipLoader } from 'react-spinners';

import { IoMdArrowBack } from 'react-icons/io';

import Swal from 'sweetalert2';

import { Switch } from 'antd';

import history from '~/services/history';

import { store } from '~/store';

import Breadcumbs from '~/components/Breadcumbs';

import ModalTermoDeAceite from '~/components/ModalTermoDeAceite';

import {
  PageTitle,
  BoxContent,
  Container,
  Content,
  FormContainer,
  BoxForm,
  TitleSection,
  Row,
  Col,
  Label,
  ButtonBox,
  SwitchButton,
} from './style';

import api from '~/services/api';

const MinhaConta = props => {
  const { register, handleSubmit, errors } = useForm();

  const [loading, setLoading] = useState(true);

  const { token, roles, systemConfig } = store.getState().auth;

  const { usuarioAssinouTermo } = systemConfig;

  const [dados, setDados] = useState(null);

  const [alterarSenha, setAlterarSenha] = useState(false);

  const [primeiroLogin, setPrimeiroLogin] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState();

  // DADOS UPDATE

  const [email, setEmail] = useState();
  const [telefone, setTelefone] = useState();
  const [senha, setSenha] = useState();
  const [novaSenha, setNovaSenha] = useState();
  const [confirmeSenha, setConfirmeSenha] = useState();

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
  const ROLE_MANAGER = roles.includes('ROLE_MANAGER');
  const ROLE_USER = roles.includes('ROLE_USER');

  const getConta = async () => {
    api
      .get(`/usuarios/minha-conta`, {
        headers: {
          Authorization: token,
        },
      })
      .then(res => {
        setDados(res.data);
        setEmail(res.data.email);
        setTelefone(res.data.telefone);
        setLoading(false);
      });
  };

  useEffect(() => {
    getConta();

    if (props.location.search.includes('?primeiro-login=true')) {
      setPrimeiroLogin(true);
      setAlterarSenha(true);
    }
  }, []);

  useEffect(() => {
    if (dados && dados.telefone)
      setPhoneNumber(Number(String(dados.telefone).replace(/([^0-9])+/g, '')));
  }, [dados]);

  const atualizarConta = async () => {
    if (alterarSenha) {
      if (!senha || !novaSenha || !confirmeSenha) {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Por favor digite sua senha atual e a nova senha.</p>`,
          icon: 'warning',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        });

        return;
      }
      if (novaSenha !== confirmeSenha) {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">A nova senha não coincide com a confirmação.</p>`,
          icon: 'warning',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        });
      }
    }

    const data = {
      senha: alterarSenha ? senha : null,
      novaSenha: alterarSenha ? novaSenha : null,
      confirmeSenha: alterarSenha ? confirmeSenha : null,
      email,
      telefone,
    };

    try {
      const response = await api.post(`usuarios/minha-conta`, data, {
        headers: {
          Authorization: token,
        },
      });

      if (String(response?.status).substr(0, 2) === '20') {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Alterações salvas
          com sucesso</p>`,
          icon: 'success',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        }).then(() => {
          history.push('/');
        });

        if (alterarSenha) {
          document.getElementById('senha').value = '';
          document.getElementById('novasenha').value = '';
          document.getElementById('confirmeSenha').value = '';
          setAlterarSenha(false);
        }
        if (primeiroLogin) setPrimeiroLogin(false);
      }

      console.log('response atualizarConta :', response);
    } catch (error) {
      if (error && error.response.data) {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">${error.response.data.fields[0].exception}</p>`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        });
      }
    }
  };

  if (loading) {
    return (
      <BoxContent>
        <div className="boxSpin">
          <ClipLoader size={50} color="#74a50a" loading={loading} />
        </div>
      </BoxContent>
    );
  }

  return (
    <>
      <ModalTermoDeAceite visible={primeiroLogin && !usuarioAssinouTermo} />
      <Breadcumbs path="minha-conta" pathTitle="Minha conta" />
      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div>
          <span>Minha conta</span>
        </div>
      </PageTitle>
      <BoxContent>
        <Container>
          <Content>
            <h3>Confira abaixo as informações da sua conta:</h3>

            {dados && (
              <FormContainer>
                <form>
                  {ROLE_USER && (
                    <div className="alerta-usuario-gestor-do-hospital">
                      <span className="titulo-alerta-usuario-gestor-do-hospital">
                        Usuário operador do hospital
                      </span>

                      <span className="texto-alerta-usuario-gestor-do-hospital">
                        Usuário com autorização para inserir dados para cálculo
                        de indicadores, verificar relatório de operações e
                        visualizar os dashboards de sua instituição de saúde.
                      </span>
                    </div>
                  )}

                  {ROLE_MANAGER && (
                    <div className="alerta-usuario-gestor-do-hospital">
                      <span className="titulo-alerta-usuario-gestor-do-hospital">
                        Usuário gestor do hospital
                      </span>

                      <span className="texto-alerta-usuario-gestor-do-hospital">
                        Cabe ao usuário Gestor do Hospital cadastrar e editar os
                        usuários gestores e operadores da sua respectiva
                        instituição, inserir dados, verificar registros de
                        envio, além de visualizar dados de sua instituição
                        através de dashboard para análise dos dados.
                      </span>
                    </div>
                  )}

                  {ROLE_ADMIN && (
                    <div className="alerta-usuario-gestor-do-hospital">
                      <span className="titulo-alerta-usuario-gestor-do-hospital">
                        Usuário administrador do sistema
                      </span>

                      <span className="texto-alerta-usuario-gestor-do-hospital">
                        Ator com funções para inserir, buscar e inativar
                        instituições de saúde e usuários. Também pode reabrir
                        competências de envio de dados e visualizar registros
                        das operações realizadas no sistema. Esse ator tem
                        acesso a todos os dados dos hospitais via dashboard de
                        indicadores.
                      </span>
                    </div>
                  )}

                  <hr />

                  <h3>
                    {primeiroLogin && (
                      <>
                        <span>
                          Atenção: Após acessar o sistema pela
                          <br /> primeira vez é necessário alterar sua senha.
                        </span>
                      </>
                    )}
                  </h3>

                  <BoxForm>
                    <div className="left">
                      <TitleSection> > Informações de acesso</TitleSection>

                      <Row>
                        <Col>
                          <Label>Desejar alterar sua senha?</Label>
                          <SwitchButton>
                            <Switch
                              checked={alterarSenha}
                              onClick={() => setAlterarSenha(!alterarSenha)}
                            />
                          </SwitchButton>
                        </Col>
                      </Row>
                      {alterarSenha && (
                        <Row>
                          <Col>
                            <Label>Redefinir sua senha: *</Label>
                            <input
                              id="novasenha"
                              name="novasenha"
                              type="password"
                              onChange={e => setNovaSenha(e.target.value)}
                            />
                            {errors.razaoSocial && (
                              <span className="errorField">
                                Campo obrigatório.
                              </span>
                            )}
                            <span className="redefinir-sua-senha-legenda">
                              As senhas devem ter no mínimo 8 (oito) caracteres,
                              contendo letras maiúsculas, minúsculas, números de
                              0 a 9 e caracteres especiais.
                            </span>
                          </Col>
                        </Row>
                      )}

                      <Row>
                        <Col className="ultimo-login">
                          <span className="label-ultimo-login">
                            Último login:
                          </span>
                          <span className="dados-ultimo-login">
                            {/* 02 de fevereiro de 2020 / 23:40 */}

                            {format(
                              parseISO(dados.ultimoLogin),
                              " dd 'de' MMMM' de 'yyyy' / ' HH:mm",
                              { locale: ptBR }
                            )}
                          </span>
                        </Col>
                      </Row>
                    </div>

                    {alterarSenha && (
                      <div className="right">
                        <TitleSection> &nbsp;</TitleSection>

                        <Row>
                          <Col>
                            <Label>Senha atual: *</Label>
                            <input
                              id="senha"
                              name="senha"
                              type="password"
                              onChange={e => setSenha(e.target.value)}
                            />
                            {errors.nomeFantasia && (
                              <span className="errorField">
                                Campo obrigatório.
                              </span>
                            )}
                          </Col>
                        </Row>

                        <Row>
                          <Col>
                            <Label>Repita nova senha: *</Label>
                            <input
                              id="confirmeSenha"
                              name="confirmeSenha"
                              type="password"
                              onChange={e => setConfirmeSenha(e.target.value)}
                            />
                            {errors.razaoSocial && (
                              <span className="errorField">
                                Campo obrigatório.
                              </span>
                            )}
                            <span className="repita-nova-senha-legenda">
                              Confirme a nova senha.
                            </span>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </BoxForm>

                  <hr />

                  <BoxForm>
                    <div className="left">
                      <TitleSection> > Informações de cadastro</TitleSection>

                      <Row>
                        <Col>
                          <Label>Nome: *</Label>
                          <input
                            name="nome"
                            type="text"
                            defaultValue={dados.nome}
                            disabled
                            className={'disabled'}
                          />
                          {errors.cep && (
                            <span className="errorField">
                              Campo obrigatório.
                            </span>
                          )}

                          <p> &nbsp; &nbsp; </p>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <Label> Instituição a que pertence: * </Label>
                          <input
                            name="nomeInstituicao"
                            type="text"
                            defaultValue={dados.nomeInstituicao}
                            disabled
                            className={'disabled'}
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="right">
                      <TitleSection> </TitleSection>
                      <br />
                      <Row>
                        <Col>
                          <Label>CPF: *</Label>
                          <input
                            name="cpf"
                            type="text"
                            defaultValue={dados.cpf}
                            disabled
                            className={'disabled'}
                          />

                          <p>Somente números.</p>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Label>Cargo na Instituição: *</Label>
                          <input
                            name="cargo"
                            type="text"
                            defaultValue={dados.cargo}
                            disabled
                            className={'disabled'}
                          />
                        </Col>
                      </Row>
                    </div>
                  </BoxForm>

                  <hr />

                  <BoxForm>
                    <div className="left">
                      <TitleSection> > Informações de contato</TitleSection>

                      <Row>
                        <Col>
                          <Label>DDD + Telefone: *</Label>
                          <input
                            name="telefone"
                            type="number"
                            defaultValue={phoneNumber}
                            onChange={e => setTelefone(e.target.value)}
                            onKeyDown={e =>
                              /[\+\-\.\,]$/.test(e.key) && e.preventDefault()
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                    <div className="right">
                      <TitleSection> </TitleSection>
                      <br />
                      <Row>
                        <Col>
                          <Label>Email: *</Label>
                          <input
                            name="email"
                            type="text"
                            defaultValue={dados.email}
                            onChange={e => setEmail(e.target.value)}
                          />

                          <p> &nbsp;&nbsp; </p>
                        </Col>
                      </Row>
                    </div>
                  </BoxForm>

                  <ButtonBox>
                    <button type="button" onClick={() => atualizarConta()}>
                      {loading ? 'Enviando dados...' : 'Salvar'}
                    </button>
                  </ButtonBox>
                  <span className="alertGreen">*Preenchimento obrigatório</span>
                </form>
              </FormContainer>
            )}
          </Content>
        </Container>
      </BoxContent>
    </>
  );
};

export default MinhaConta;
